import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useSuccessPageAttribution } from 'hooks/useSuccessPageAttribution';

import ChimeAnonymousIdHiddenInput from './ChimeAnonymousIdHiddenInput';

const SuccessPageAttribution = ({ children }) => {
  const { deprecatedFireSuccessAttribution } = useSuccessPageAttribution();

  useEffect(() => {
    deprecatedFireSuccessAttribution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {children}
      <ChimeAnonymousIdHiddenInput />
    </>
  );
};

SuccessPageAttribution.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SuccessPageAttribution;
